// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DialogReportPaid__Component__Loading .checkbox {\n  margin: 0 !important;\n}\n.DialogReportPaid__Component__Loading .checkbox span:first-of-type {\n    margin: 0 0 0 5px !important;\n}\n.DialogReportPaid__Component__Loading .activity-container {\n  display: flex;\n}\n", ""]);
// Exports
module.exports = exports;
